<template>
  <div>
    <label :for="labelId" class="block text-sm font-medium leading-6 text-gray-900 mb-2" v-if='!props.hideLabel'>{{ props.label }}</label>
    <input type="number" :id="labelId" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-jananavy-600 sm:text-sm sm:leading-6" v-model='model' />
  </div>
</template>

<script setup>

import { nanoid } from 'nanoid';

import { computed } from 'vue';

const model = defineModel();

const props = defineProps({
  label: String,
  hideLabel: Boolean,
  labelId: String
});

const labelId = computed(() => {
  return props.labelId || nanoid();
});

</script>